import React from 'react';
import { Box } from '@mui/material';
import 'react-alice-carousel/lib/alice-carousel.css'; // requires a loader
import AliceCarousel from 'react-alice-carousel';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
const data = [
	{
		title: 'Chalo Thailand',
		day: 5,
		night: 4,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/52/600x300/2959822-2959821_pattaya.jpg',
		amount: '30,499',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/52/600x300/2959822-2959821_pattaya.jpg',
		],
	},
	{
		title: 'Delight Krabi and Phuket with Flights',
		day: 6,
		night: 5,
		image:
			'https://cdn.yourholiday.me/static/dynimg/destination/57/600x300/1722397-1722396_2jpg.jpg',
		amount: '51,699',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/destination/57/600x300/1722397-1722396_2jpg.jpg',
		],
	},
	{
		title: 'Wonders of Europe (Summer 2023)',
		day: 13,
		night: 12,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/38/600x300/2990875-2990874_swiss.jpg',
		amount: '260,999',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/38/600x300/2990875-2990874_swiss.jpg',
		],
	},
	{
		title: 'Romantic Switzerland and Paris (Summer 2023)',
		day: 10,
		night: 9,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/92/600x300/2993422-2993421_picture1-min-12.jpg',
		amount: '241,999',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/92/600x300/2993422-2993421_picture1-min-12.jpg',
		],
	},
];
const CarouselInterHoliday = () => {
	// const { hotel } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const history = useHistory();
	const responsive = {
		0: { items: 1 },
		568: { items: 2 },
		1024: { items: 4 },
	};
	const items = data.map((i, index) => {
		return (
			<div
				onClick={() => history.push({ pathname: '/detail', state: i })}
				style={{ cursor: 'pointer', marginTop: 20 }}
				className='item'
				data-value='1'>
				<Box style={{ width: '90%' }}>
					<Box>
						<img
							src={i.image}
							style={{ width: '100%', height: 160, borderRadius: 5 }}
						/>
					</Box>
					<Box style={{ textAlign: 'initial', padding: 10 }}>
						<span
							style={{
								color: '#0c2f54',
								// fontFamily: '"Poppins", sans-serif',
								fontWeight: 'bold',
								fontSize: 14,
							}}>
							{i.title}
						</span>
						<br></br>
						<Box display='flex' alignItems='center' style={{ marginTop: 5 }}>
							<Box display='flex' alignItems='center'>
								<i class='far fa-clock'></i>
								<span
									style={{
										color: '#0c2f54',
										// fontFamily: '"Poppins", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 14,
									}}>
									{i.day} Days
								</span>
							</Box>
							<Box display='flex' alignItems='center' ml={'10px'}>
								<i class='far fa-moon'></i>
								<span
									style={{
										color: '#0c2f54',
										// fontFamily: '"Poppins", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 14,
									}}>
									{i.night} Nights
								</span>
							</Box>
						</Box>
						<Box display='flex' alignItems='center' style={{ marginTop: 5 }}>
							<Box display='flex' alignItems='center'>
								{/* <i class='far fa-clock'></i> */}
								<span
									style={{
										color: '#0c2f54',
										// fontFamily: '"Poppins", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 16,
									}}>
									₹ {i.amount}
								</span>
							</Box>
						</Box>
					</Box>
					{/* <Box style={{ background: '#0c2e53', padding: 10 }}>
						<span style={{ color: 'white' }}> Starting From ₹{800} </span>
					</Box> */}
				</Box>
			</div>
		);
	});
	const demo = [
		<div className='item' data-value='1'>
			1
		</div>,
		<div className='item' data-value='2'>
			2
		</div>,
		<div className='item' data-value='3'>
			3
		</div>,
		<div className='item' data-value='4'>
			4
		</div>,
		<div className='item' data-value='5'>
			5
		</div>,
	];

	return (
		<AliceCarousel
			autoPlay
			infinite
			mouseTracking
			items={items}
			autoPlayInterval={3000}
			responsive={responsive}
			controlsStrategy='alternate'
			keyboardNavigation={true}
			renderPrevButton={() => {
				return <></>;
			}}
			renderNextButton={() => {
				return <></>;
			}}
		/>
	);
};

export default CarouselInterHoliday;
